import React from 'react';
import { Award, Clock } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import GameSetup from '../components/GameSetup';
import WordChain from '../components/WordChain';
import PlayerInput from '../components/PlayerInput';
import GameOver from '../components/GameOver';
import Rules from '../components/Rules';
import { useGame } from '../contexts/GameContext';

const GamePage = () => {
  const { 
    gameState, 
    score, 
    timeLeft,
    isDictionaryLoading,
    errorMessage,
    setErrorMessage
  } = useGame();
  
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      
      <main className="flex-grow container mx-auto px-4 py-8">
        <div className="text-center mb-6">
          <h1 className="text-3xl font-bold text-emerald-600 mb-2">ئۇيغۇرچە سۆز زەنجىرى</h1>
          <p className="text-gray-600 uyghur-text">كەلىمە زەنجىرى ئويۇنىغا خۇش كەلدىڭىز!</p>
        </div>
        
        {isDictionaryLoading ? (
          // Loading state
          <div className="game-card text-center py-12">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-emerald-500 mx-auto mb-4"></div>
            <p className="text-gray-600 uyghur-text">لۇغەت يۈكلىنىۋاتىدۇ...</p>
            <p className="text-xs text-gray-500 mt-2">35,000+ ئۇيغۇرچە سۆز</p>
          </div>
        ) : (
          <>
            {gameState === 'setup' && <GameSetup />}
            
            {gameState === 'playing' && (
              <div className="game-card">
                <div className="flex justify-between items-center mb-4">
                  <div className="badge badge-green flex items-center">
                    <Award size={14} className="mr-1" />
                    <span className="uyghur-text">نومۇر: {score}</span>
                  </div>
                  
                  {timeLeft > 0 && (
                    <div className={`badge flex items-center ${
                      timeLeft > 10 ? 'badge-green' : 'badge-red'
                    }`}>
                      <Clock size={14} className="mr-1" />
                      <span className="uyghur-text">{timeLeft} سېكۇنت</span>
                    </div>
                  )}
                </div>
                
                <WordChain />
                
                <PlayerInput />
                
                {errorMessage && (
                  <div className="mt-3 text-center text-amber-600 uyghur-text">
                    {errorMessage}
                    <button 
                      className="ml-2 text-xs text-gray-500 hover:text-gray-700"
                      onClick={() => setErrorMessage('')}
                    >
                      ✕
                    </button>
                  </div>
                )}
              </div>
            )}
            
            {gameState === 'gameOver' && <GameOver />}
            
            {/* Rules are always visible */}
            <Rules />
          </>
        )}
      </main>
      
      <Footer />
    </div>
  );
};

export default GamePage;